/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */

function getPassAwayWreathFunctoinConfig() {
  const pass_away_wreath__benefits_withdrawn_from_calculation__value = (values, defaultValue) => {
    return Math.floor(Math.min(values.total_receipt_amount || 0, 3000))
  }
  const pass_away_wreath__benefits_approve__value = (values, defaultValue) => {
    return Math.min(values.total_receipt_amount || 0, 3000)
  }

  const validate = (values, defaultValues) => {
    return true
  }

  return {
    autoCal: {
      pass_away_wreath__benefits_withdrawn_from_calculation__value,
      pass_away_wreath__benefits_approve__value,
    },
    validate: { validate },
  }
}
